import { COUNTRIES, CountryCode } from 'lib/constants/locales';
import { ApiModel } from 'lib/interfaces/api';
import { VerificationStatus } from 'lib/verification';
import { isDynamicFlowInquiry } from 'verify/lib/inquiry';
import { Inquiry, InquiryStatus } from 'verify/models/inquiry';
import { Organization } from 'verify/models/organization';
import { Template } from 'verify/models/template';
import { Verification } from 'verify/models/verification';

const ALL_COUNTRY_KEYS = Object.keys(COUNTRIES) as CountryCode[];
const ALL_COUNTRY_KEYS_SET = new Set<CountryCode>(ALL_COUNTRY_KEYS);

export function getAllowedCountriesList(allowedCountryCodes: CountryCode[]): CountryCode[] {
  return allowedCountryCodes.length === 0
    ? ALL_COUNTRY_KEYS
    : allowedCountryCodes.filter((countryCode) => ALL_COUNTRY_KEYS_SET.has(countryCode));
}

export function shouldShowSupport(
  organization: Organization,
  template: Template,
  inquiry: Inquiry,
  verifications: Verification[],
) {
  if (
    template == null ||
    inquiry == null ||
    verifications == null ||
    isDynamicFlowInquiry(inquiry)
  ) {
    return false;
  }

  if (
    [
      InquiryStatus.Completed,
      InquiryStatus.Approved,
      InquiryStatus.Declined,
      InquiryStatus.NeedsReview,
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    ].includes(inquiry.attributes.status)
  ) {
    return false;
  }

  if (organization == null || !template.attributes['has-support']) {
    return false;
  }

  // Don't show if last verification was passed
  if (
    verifications.length > 0 &&
    verifications[verifications.length - 1].attributes.status === VerificationStatus.Passed
  ) {
    return false;
  }

  const failedVerifications = verifications.filter((verification) =>
    [
      VerificationStatus.Failed,
      VerificationStatus.RequiresRetry,
      VerificationStatus.Canceled,
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    ].includes(verification.attributes.status),
  );

  return failedVerifications.some((v) => v.type !== ApiModel.VerificationDatabase);
}
